<template>
    <v-card class="p-3">
        <h5>Campagnes en cours
        <span v-if="!loading && campaigns.length">({{campaigns.length}})</span>
        </h5>
        <v-skeleton-loader v-if="loading" type="table-tbody" class="mt-3"></v-skeleton-loader>
        <v-simple-table fixed-header v-else-if="campaigns.length">
            <thead>
                <tr>
                    <th class="text-left">Nom</th>
                    <th class="text-left">Type</th>
                    <th class="text-left">Statut</th>
                    <th class="text-left">Formulaire</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="campaign in campaigns" :key="campaign.id">
                    <td>
                        <a @click="redirectCampaign(campaign)">
                            {{ campaign.name }}
                        </a>
                    </td>
                    <td>{{ campaign.type === 'CMAJ'? 'Mise à jour' : 'Partenariat' }}
                        <span v-if="campaign.type === 'CMAJ' && campaign.aspect !== null">
                            {{getAspectIcon(campaign)}}
                        </span>
                    </td>
                    <td>{{ campaign.state.label }}</td>
                    <td>{{ campaign.form_state }}</td>
                </tr>
            </tbody>
        </v-simple-table>
        <div class="text-center" v-else>
            <small>
                Aucune campagne
            </small>
        </div>
    </v-card>
</template>

<script>
export default {
    name: "CampaignBloc",
    props: ['providerId'],
    data() {
        return {
            campaigns: [],
            loading: true,
        }
    },
    methods: {
        redirectCampaign(campaign) {
            let type = campaign.type === 'CMAJ' ? 'cmaj' : 'cadh'

            this.$router.push('/campaign/' + type + '/' + this.encodeUri(campaign.id))
        },
        encodeUri(id) {
            return btoa(id)
        },
        getCampaigns() {
            this.loading = true
            this.$http.get('auth/providers/' + this.providerId + '/campaigns').then(res => {
                this.campaigns = res.body.data.campaigns
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        getAspectIcon(campaign) {
                if(campaign.aspect === 'business') {
                    return '💼'
                } else if(campaign.aspect === 'summer') {
                    return '🔆'
                } else if(campaign.aspect === 'winter') {
                    return '❄️'
                }
        }
    },
    created() {
        this.getCampaigns()
    }
}
</script>